// src/components/App/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Hooks/useAuth';
import { TimeTrackProvider } from '../TimeTrack/context/TimeTrackContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  // console.log('ProtectedRoute: User object:', user);
  // console.log('ProtectedRoute: Loading state:', loading);

  // Show a loading indicator while checking authentication state
  if (loading) {
    // console.log('ProtectedRoute: Still loading, showing loading indicator');
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to the login page if the user is not authenticated
  if (!user) {
    // console.log('ProtectedRoute: No user, redirecting to login');
    return <Navigate to="/auth" />;
  }

  // Render the protected component if the user is authenticated
  // console.log('ProtectedRoute: User authenticated, rendering children');
  return <TimeTrackProvider>{children}</TimeTrackProvider>;
}

export default ProtectedRoute;
